import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    documentId: 0,
    loadStatus: "none",
    images: [],
    thumbnails: []
  }
};
const docImageSlice = createSlice({
  name: "docImage",
  initialState,
  reducers: {
    updateDocImages: (state, action) => {
      console.log(action);
      state.value = {
        documentId: action.payload.documentId,
        loadStatus: "loaded",
        images: action.payload.images,
        thumbnails: []
      };
    },
    clearDocImages: (state) => {
      state.value = {
        documentId: 0,
        loadStatus: "none",
        images: [],
        thumbnails: []
      };
    },
    startImageLoad: (state, action) => {
      state.value = {
        documentId: action.payload.docId,
        loadStatus: "loading",
        images: [],
        thumbnails: []
      };
    },
    loadPage: (state, action) => {
      let newState = { ...state.value };
      newState.images = [...newState.images];
      let page = newState.images.find((f) => f.pageId === action.payload.pageId);
      console.log(page);
      let idx = newState.images.indexOf(page);
      console.log(idx);
      console.log(newState);
      newState.images[idx] = action.payload;
      state.value = newState;
    }
  }
});
export const { updateDocImages, clearDocImages, startImageLoad, loadPage } = docImageSlice.actions;
export default docImageSlice.reducer;
